(function () {
  function onReady(fn){
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  onReady(function () {
    var roots = document.querySelectorAll(".inkdStopSwag");
    if (!roots.length) return;

    roots.forEach(function(root){
      var pills = root.querySelectorAll(".inkdStopSwag__pill");
      if (!pills.length) return;

      var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (reduce) return;

      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (!e.isIntersecting) return;
          pills.forEach(function(p, i){
            p.style.willChange = "transform, opacity";
            p.style.opacity = "0";
            p.style.transform = "translateY(6px)";
            setTimeout(function(){
              p.style.transition = "transform 260ms ease, opacity 260ms ease";
              p.style.opacity = "1";
              p.style.transform = "translateY(0)";
            }, 60 + i * 70);
          });
          io.disconnect();
        });
      }, { threshold: 0.25 });

      io.observe(root);
    });
  });
})();
